<template>
  <CFooter :fixed="false" />
</template>


<script>
export default {
  name: 'TheFooter'
}
</script>
